import React from 'react'
import {Formik} from 'formik'
import {forgotPassword,getUser, login, verifyCode} from '../actions/auth'
import {connect} from 'react-redux'
import {withRouter, Link} from 'react-router-dom'
import { CSSTransition } from "react-transition-group"
import * as qs from 'query-string';

class VerifyCode extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            formState: 'INITIAL',
            isEmailSubmitted: false,
            isCodeSubmitted:false,
            email:""
        }

    }

    render(){
        let param = qs.parse(this.props.location.search)
        console.log(param.code)
        let {
            dispatch
        } = this.props

        let {
            formState,
            isEmailSubmitted,
            isCodeSubmitted
        } = this.state


        // let data={
        //     email:email,
        //     password:password
        // }
        const NotificationMessage = {
            INITIAL: {
                message: "Please Enter Code",
                alertClass: "alert-primary"
            },
            SUCCESS: {
                message: "Code is Correct",
                alertClass: "alert-success"
            },
            ERROR: {
                message: "Code is Incorrect",
                alertClass: "alert-danger"
            }
        }

        return (
            <div>
                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={5000}
                    classNames="fade"
                >
                <div className="forgot-center-wrapper">
                
                <div className="forgot-center-div">
                    <Formik
                        initialValues={{email: '',code:''}}
                        onSubmit={values => {
                            let category = 'forgotPassword'
                                console.log(values)

                                let getEmail = this.state.email
                                values.code == param.code ? this.props.history.push("/update-password?id="+param.id) : alert('Wrong code')

                                
                            }
                        }
                        
                        render={({
                            handleSubmit,
                            handleChange,
                            values
                        }) => (
                            <div className="login-view-wrapper">
                                    
                                <form
                                    onSubmit={handleSubmit}
                                    className="container"
                                >
                                    <div className='form-group'>
                                    <CSSTransition
                                            in={true}
                                            timeout={500}
                                            classNames="fade" 
                                    >
                                        <div className={`col s12 waves-effect pulse alert ${NotificationMessage[formState].alertClass}`}>
                                            <span>{NotificationMessage[formState].message}</span>
                                        </div>
                                    </CSSTransition>
                                    </div>
                                    <div className='form-group'>
                                            <input 
                                                className='form-control' 
                                                type='text' 
                                                name='code' 
                                                id='code' 
                                                onChange={handleChange} 
                                                value={values.code}
                                                placeholder="Code"
                                            />
                                    </div>
                                    <center>
                                        <div className='form-group mt-3'>
                                            <button 
                                                type='submit' 
                                                name='btn_login' 
                                                className='btn' 
                                                onClick={(e)=>{
                                                    // console.log("this.dispatch",this.props)
                                                }}
                                                >
                                                    Submit Reset Code
                                            </button>
                                        </div>
                                        <div className='form-group mt-3'>
                                            <Link to="/">Back to Login Page</Link>
                                        </div>
                                    </center>
                                </form>
                            </div>
                        )}
                    />
                </div>
            </div></CSSTransition>
        </div>//End of entire wrapping Div
        )
    }
}

function mapStateToProps(){
    return {}
}

export default withRouter(connect(mapStateToProps)(VerifyCode))


// WEBPACK FOOTER //
// ./src/components/verifyCode.js